import {dateConvert}         from "../../../plugins/utils";
import reservation_resources from "../../base/reservation_resources";

const resources = {
    ...reservation_resources,
    kiosk_config    : {'__remote': true}
};

export default resources;
